<template>
  <div class="col-md-12 p-0 mb-4 report-create-page">
    <!-- popup client  -->
    <PopupContract
      v-on:exit="closeModal"
      v-on:applyData="applyContract"
      v-if="isEnablePopup == 'contract'"
    />

    <PopupSection
      v-if="isEnablePopup == 'section'"
      v-on:exit="closeModal"
      v-on:applyData="AssignSection"
      :id_contract="idContract"
    />

    <PopupSectionTaskGallery
      v-if="isEnablePopup == 'section_task'"
      v-on:exit="closeModal"
      v-on:applyData="AssignSectionTaskImage"
      :section_task="SectionTask"
      :image_type="typeImage"
      :list_check_images_before_after="listCheckImagesBeforeAfter"
      :filter_period_start_date="filter_start_date_period"
      :filter_period_end_date="filter_end_date_period"
    />

    <PopupSectionTaskGalleryNew
      v-if="isEnablePopup == 'open_gallery_new'"
      v-on:exit="closeModal"
      v-on:applyData="AssignSectionTaskImageNew"
      :gallery_image_type="galleryImageType"
      :section_task="SectionTask"
      :filter_period_start_date="filter_start_date_period"
      :filter_period_end_date="filter_end_date_period"
    />

    <PopupGallerySelected
      v-if="isEnablePopup == 'images_selected'"
      v-on:exit="closeModal"
      v-on:applyData="AssignImage"
      :list_images_selected="listImagesSelectedGenerate"
    />

    <section class="report-create-hero">
      <div>
        <span class="report-create-hero__eyebrow">MONTHLY OPERATIONAL REPORT</span>
        <h2>Create Generate Report</h2>
        <p>Susun laporan kontrak, pilih area kerja, dan lengkapi dokumentasi dalam satu alur.</p>
      </div>
      <router-link :to="{ name: 'report/generate-report' }" class="report-back-btn">
        <i class="ti ti-arrow-left"></i> Back to Report
      </router-link>
    </section>

    <form class="form-horizontal">
      <div class="card report-create-card">
        <div class="card-body">
          <div class="report-create-header">
            <div class="report-create-header__title">
              <span class="report-create-header__icon"><i class="ti ti-write"></i></span>
              <div>
                <h5>Report Configuration</h5>
                <small>Pilih kontrak, periode laporan, dan section yang akan ditampilkan.</small>
              </div>
            </div>
            <div class="report-create-actions" v-if="this.SectionChecked.length > 0">
              <a
                class="btn report-generate-btn"
                @click="generateReport()"
              >
                <span v-if="$store.state.loading.status">
                  <i class="ti ti-reload"></i> Loading...</span
                >
                <span v-else
                  ><i class="ti ti-save-alt"></i> Generate Report</span
                >
              </a>
              <a
                class="btn report-clear-btn"
                @click="clearAlldata()"
              >
                <span><i class="ti ti-close"></i> Clear</span>
              </a>
            </div>
          </div>
          <!-- <div class="form-group">
            <label class="col-sm-3"
              >Branch Station <small class="text-danger">*</small></label
            >
            <div class="col-sm-9">
              <SelectBranch
                v-on:processBranch="processBranch"
                :title="'disable'"
              />
              
            </div>
          </div> -->

          <div class="report-create-steps">
          <div class="form-group report-step" :class="{ 'report-step--complete': contract }">
            <div class="mt-2 report-step__inner">
              <div class="report-step__number">1</div>
              <div class="col-sm-3 report-step__label">
                Contract Project
                <small>Pilih kontrak laporan.</small>
              </div>
              <div class="col-sm-9 report-step__control">
                <a
                  href="javascript:;"
                  class="report-picker-btn"
                  @click="isEnablePopup = 'contract'"
                  ><i class="ti ti-briefcase"></i>
                  <span v-if="!this.contract">Choose Contract...</span>
                  <span v-else>
                    {{ contract.contract_number }} -
                    <b>{{ contract.client_name }}</b>
                  </span>
                </a>
              </div>
            </div>
          </div>
          <div
            class="form-group report-step"
            :class="{ 'report-step--complete': filter_start_date_period }"
            v-if="this.contract"
          >
            <div class="mt-2 report-step__inner">
              <div class="report-step__number">2</div>
              <div class="col-sm-3 report-step__label">
                Date Period
                <small>Tentukan periode aktivitas.</small>
              </div>
              <div class="col-sm-9 report-step__control">
                <date-picker
                  v-model="filter_date"
                  :default-value="filter_date"
                  :disabled-date="disabledBeforeAfterFilterDate"
                  :clearable="false"
                  value-type="format"
                  type="date"
                  format="DD/MM/YYYY"
                  placeholder="Pilih Range Tanggal"
                  width="100%"
                  @change="FilterModelDate()"
                  confirm
                  range
                ></date-picker>
              </div>
            </div>
          </div>
          <div
            class="form-group report-step"
            :class="{ 'report-step--complete': SectionChecked.length > 0 }"
            v-if="this.filter_start_date_period"
          >
            <div class="mt-2 report-step__inner">
              <div class="report-step__number">3</div>
              <div class="col-sm-3 report-step__label">
                Section Contract Project
                <small>Pilih section dan area.</small>
              </div>
              <div class="col-sm-9 report-step__control">
                <a
                  href="javascript:;"
                  class="report-picker-btn"
                  @click="isEnablePopup = 'section'"
                >
                  <i class="ti ti-layout-grid2"></i>
                  <span>Choose Section...</span>
                  <span class="report-picker-count" v-if="SectionChecked.length > 0">
                    {{ SectionChecked.length }} selected
                  </span>
                </a>
                <div
                  v-if="SectionChecked.length > 0"
                  class="report-selected-sections"
                >
                  <span
                    v-for="(item, index) in SectionChecked"
                    :key="index"
                    class="report-section-chip"
                  >
                    <i class="ti ti-check"></i>
                    {{ item.area_type }} - {{ item.area_name }}
                  </span>
                </div>
              </div>
            </div>
          </div>
          </div>
          <div
            class="row justify-content-md-center m-0 report-documentation"
            v-if="this.SectionChecked.length > 0"
          >
            <div class="col-md-12 report-documentation__header">
              <div>
                <span class="report-documentation__icon"><i class="ti ti-gallery"></i></span>
                <div>
                  <h5>Activity Documentation</h5>
                  <small>Lengkapi foto before-after dan dokumentasi pendukung laporan.</small>
                </div>
              </div>
              <span class="report-documentation__summary">
                {{ listSelectedImagesBeforeAfter.length }} pairs ·
                {{ listSelectedImagesOther.length }} other
              </span>
            </div>
            <div class="col-md-8 report-documentation__column">
              <div class="bd-callout bd-callout-warning">
                <h5 id="conveying-meaning-to-assistive-technologies">
                  Before &amp; After
                </h5>
              </div>
              <div v-if="listSelectedImagesBeforeAfter.length > 0">
                <div
                  class="row"
                  v-for="(item, idx) in listSelectedImagesBeforeAfter"
                  :key="idx"
                >
                  <div class="col-md-12 mt-3" v-if="idx > 0"></div>

                  <div class="col-md-2" style="align-self: self-end">
                    No. {{ idx + 1 }}
                  </div>

                  <div class="col-md-10" style="text-align: end">
                    <a
                      href="javascript:;"
                      class="btn btn-sm report-update-image-btn"
                      @click="updateImageBeforeAfter(idx)"
                    >
                      Update Image Before After
                    </a>
                  </div>

                  <div class="col-md-12 mb-1"></div>

                  <div class="col-md-6 card report-image-card">
                    <img
                      :src="item.img_before_photo"
                      class="card-img-top"
                      :alt="item.img_before_notes"
                    />
                    <div
                      style="
                        position: absolute;
                        top: 14px;
                        background-color: rgba(34, 32, 32, 0.3);
                        padding: 6px;
                        color: #fff;
                      "
                    >
                      Before
                    </div>
                    <div
                      class="card-body"
                      style="
                        padding: 3%;
                        border-left: 1px solid #eee;
                        border-right: 1px solid #eee;
                      "
                    >
                      <h5
                        class="card-title"
                        style="
                          position: absolute;
                          bottom: 124px;
                          color: #ffffff;
                          padding: 12px;
                          left: 14px;
                          right: 14px;
                          background-color: rgb(34 32 32 / 30%);
                        "
                        v-if="item.img_before_notes"
                      >
                        {{ item.img_before_notes }}
                      </h5>
                      <p class="card-text">
                        Section {{ item.img_before_section }} -
                        {{ item.img_before_area_type }} -
                        {{ item.img_before_area }}
                      </p>
                    </div>
                    <div
                      class="card-footer"
                      style="
                        padding: 3%;
                        border-bottom: 1px solid #eee;
                        border-left: 1px solid #eee;
                        border-right: 1px solid #eee;
                      "
                    >
                      <small class="text-muted"
                        >Date work {{ item.img_before_date_work }} - (Pukul
                        {{ item.img_before_time }})</small
                      >
                    </div>
                  </div>

                  <div class="col-md-6 card report-image-card">
                    <img
                      :src="item.img_after_photo"
                      class="card-img-top"
                      :alt="item.img_after_notes"
                    />
                    <div
                      style="
                        position: absolute;
                        top: 14px;
                        background-color: rgba(34, 32, 32, 0.3);
                        padding: 6px;
                        color: #fff;
                      "
                    >
                      After
                    </div>
                    <div
                      class="card-body"
                      style="
                        padding: 3%;
                        border-left: 1px solid #eee;
                        border-right: 1px solid #eee;
                      "
                    >
                      <h5
                        class="card-title"
                        style="
                          position: absolute;
                          bottom: 124px;
                          color: #ffffff;
                          padding: 12px;
                          left: 14px;
                          right: 14px;
                          background-color: rgb(34 32 32 / 30%);
                        "
                        v-if="item.img_after_notes"
                      >
                        {{ item.img_after_notes }}
                      </h5>
                      <p class="card-text">
                        Section {{ item.img_after_section }} -
                        {{ item.img_after_area_type }} -
                        {{ item.img_after_area }}
                      </p>
                    </div>
                    <div
                      class="card-footer"
                      style="
                        padding: 3%;
                        border-bottom: 1px solid #eee;
                        border-left: 1px solid #eee;
                        border-right: 1px solid #eee;
                      "
                    >
                      <small class="text-muted"
                        >Date work {{ item.img_after_date_work }} - (Pukul
                        {{ item.img_after_time }})</small
                      >
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div class="col-md-4 report-documentation__column">
              <div class="bd-callout bd-callout-warning">
                <h5 id="conveying-meaning-to-assistive-technologies">
                  Other / Highlight
                </h5>

                <div
                  class="row"
                  v-for="(item, idx) in listSelectedImagesOther"
                  :key="idx"
                >
                  <div class="col-md-12 mt-3" v-if="idx > 0"></div>

                  <div class="col-md-4" style="align-self: self-end">
                    No. {{ idx + 1 }}
                  </div>

                  <div class="col-md-8" style="text-align: end">
                    <a
                      href="javascript:;"
                      class="btn btn-sm report-delete-image-btn"
                      @click="deleteImageOther(idx)"
                    >
                      Delete Image Other
                    </a>
                  </div>

                  <div class="col-md-12 mb-1"></div>

                  <div class="col-md-12 card report-image-card">
                    <img
                      :src="item.img_other_photo"
                      class="card-img-top"
                      :alt="item.img_other_notes"
                    />
                    <div
                      style="
                        position: absolute;
                        top: 14px;
                        background-color: rgba(34, 32, 32, 0.3);
                        padding: 6px;
                        color: #fff;
                      "
                    >
                      Other
                    </div>
                    <div
                      class="card-body"
                      style="
                        padding: 3%;
                        border-left: 1px solid #eee;
                        border-right: 1px solid #eee;
                      "
                    >
                      <h5
                        class="card-title"
                        style="
                          position: absolute;
                          bottom: 124px;
                          color: #ffffff;
                          padding: 12px;
                          left: 14px;
                          right: 14px;
                          background-color: rgb(34 32 32 / 30%);
                        "
                        v-if="item.img_other_notes"
                      >
                        {{ item.img_other_notes }}
                      </h5>
                      <p class="card-text">
                        Section {{ item.img_other_section }} -
                        {{ item.img_other_area_type }} -
                        {{ item.img_other_area }}
                      </p>
                    </div>
                    <div
                      class="card-footer"
                      style="
                        padding: 3%;
                        border-bottom: 1px solid #eee;
                        border-left: 1px solid #eee;
                        border-right: 1px solid #eee;
                      "
                    >
                      <small class="text-muted"
                        >Date work {{ item.img_other_date_work }} - (Pukul
                        {{ item.img_other_time }})</small
                      >
                    </div>
                  </div>
                </div>
              </div>
            </div>

            <div class="col-md-8 mt-4">
              <a
                href="javascript:;"
                @click="openNewGallery('BeforeAfter')"
                class="btn report-gallery-btn"
                ><i class="ti ti-upload"></i>&nbsp; Add Image Before & After...
              </a>
            </div>
            <div class="col-md-4 mt-4">
              <a
                href="javascript:;"
                @click="openNewGallery('Other')"
                class="btn report-gallery-btn"
                ><i class="ti ti-upload"></i>&nbsp; Choose Image Other...
              </a>
            </div>
            <br />
            <!-- old style -->
            <!-- <div class="col-sm-4 mt-4">
              <a
                href="javascript:;"
                @click="openGallery('before')"
                class="btn btn-light"
                ><i class="ti ti-upload"></i>&nbsp; Choose Image Before ...
              </a>
              <div class="col-md-12 mt-3 p-0">
                <img
                  v-for="(item, idx) in listImagesBefore"
                  :key="idx"
                  :src="item.photo"
                  class="mr-1 p-1"
                  :alt="item.notes"
                  width="80"
                  height="80"
                />
              </div>
            </div>
            <div class="col-sm-4 mt-4">
              <a
                href="javascript:;"
                @click="openGallery('after')"
                class="btn btn-light"
                ><i class="ti ti-upload"></i>&nbsp; Choose Image After ...
              </a>
              <div class="col-md-12 mt-3 p-0">
                <img
                  v-for="(item, idx) in listImagesAfter"
                  :key="idx"
                  :src="item.photo"
                  class="mr-1 p-1"
                  :alt="item.notes"
                  width="80"
                  height="80"
                />
              </div>
            </div>
            <div class="col-sm-4 mt-4">
              <a
                href="javascript:;"
                @click="openGallery('other')"
                class="btn btn-light"
                ><i class="ti ti-upload"></i>&nbsp; Choose Image Other ...
              </a>
              <div class="col-md-12 mt-3 p-0">
                <img
                  v-for="(item, idx) in listImagesOther"
                  :key="idx"
                  :src="item.photo"
                  class="mr-1 p-1"
                  :alt="item.notes"
                  width="80"
                  height="80"
                />
              </div>
            </div> -->
            <!-- end old style -->
          </div>
        </div>
      </div>
      <!-- v-if="isGenerateReport" -->
      <div class="card mt-4 report-preview-card" v-if="isGenerateReport">
        <div class="row p-4" v-if="$store.state.loading.status">
          <div class="col-md-6">
            <ListLoader
              :speed="1"
              primaryColor="#f3f3f3"
              secondaryColor="#ecebeb"
            ></ListLoader>
          </div>
          <div class="col-md-6">
            <ListLoader
              :speed="1"
              primaryColor="#f3f3f3"
              secondaryColor="#ecebeb"
            ></ListLoader>
          </div>
          <div class="col-md-12">
            <ContentLoader
              :speed="1"
              primaryColor="#f3f3f3"
              secondaryColor="#ecebeb"
            >
              <rect x="0" y="0" rx="2" ry="2" width="400" height="250" />
            </ContentLoader>
          </div>
        </div>
        <div v-else class="view-generate" id="printView">
          <!-- <GenerateReport
            :generate_report="resultGenerateReport"
            v-on:applyData="ApplyGenerateReportSave"
          ></GenerateReport> -->
          <GenerateReportV2
            :generate_report="resultGenerateReport"
            v-on:applyData="ApplyGenerateReportSave"
          ></GenerateReportV2>
        </div>
      </div>
    </form>
  </div>
</template>

<script>
import { mapState } from "vuex";
import axios from "axios";
import $ from "jquery";
import Gmap from "../../../services/Gmap";
import { ContentLoader, ListLoader, CodeLoader } from "vue-content-loader";
import router from "../../../router";
// import PopupClientMaster from "../../ClientBase/Master/@PopupClientMaster";
import PopupContract from "./@PopupContract.vue";
import PopupSection from "./@PopupSection.vue";
import PopupSectionTaskGallery from "./@PopupSectionTaskGallery.vue";
import PopupSectionTaskGalleryNew from "./@PopupSectionTaskGalleryNew.vue";
import PopupGallerySelected from "./@PopupGallerySelected.vue";
import GenerateReport from "./@GenerateReport";
import GenerateReportV2 from "./@GenerateReportNew";
import SelectBranch from "../../Branch/@SelectBranch";
import DatePicker from "vue2-datepicker";
import "vue2-datepicker/index.css";
import "vue2-datepicker/locale/id";

export default {
  components: {
    Gmap,
    PopupContract,
    PopupSection,
    PopupSectionTaskGallery,
    PopupSectionTaskGalleryNew,
    PopupGallerySelected,
    GenerateReport,
    GenerateReportV2,
    DatePicker,
    SelectBranch,
    ContentLoader,
    ListLoader,
    CodeLoader,
  },
  data() {
    return {
      isEnablePopup: false,
      idContract: null,
      filter_date: null,
      filter_start_date_period: null,
      filter_end_date_period: null,
      filter_year: null,
      filter_month: null,
      filter_year_start: null,
      filter_year_end: null,
      filter_month_start: null,
      filter_month_end: null,
      contract: null,
      typeImage: null,
      isGenerateReport: false,
      galleryImageType: null,
      ContractShiftMonthly: [],
      SectionChecked: [],
      SectionTask: [],
      idSectionChecked: [],
      listCheckImagesBeforeAfter: [],
      listSelectedImagesBeforeAfter: [],
      listSelectedImagesOther: [],
      SelectedUpdateImagesBeforeAfter: null,
      SelectedUpdateImagesOther: null,
      listImagesBefore: [],
      listImagesAfter: [],
      listImagesOther: [],
      resultGenerateReport: {},
      listImagesSelectedGenerate: [],
      ImagesSelectedNotes: {
        photo: null,
        notes: null,
      },
      meta_url: "report/generate",
      notes_default: null,
    };
  },
  computed: {
    ...mapState("crud", {
      msg_error: (state) => state.error,
    }),
  },
  created() {},
  mounted() {},
  methods: {
    processBranch(data) {
      // console.log(data);
    },
    closeModal() {
      this.isEnablePopup = false;
    },
    clearAlldata() {
      this.SectionChecked = [];
      this.idSectionChecked = [];
      this.listCheckImagesBeforeAfter = [];
      this.listSelectedImagesBeforeAfter = [];
      this.listSelectedImagesOther = [];
      this.SelectedUpdateImagesBeforeAfter = null;
      this.SelectedUpdateImagesOther = null;
      this.listImagesBefore = [];
      this.listImagesAfter = [];
      this.listImagesOther = [];
      this.isGenerateReport = false;
      this.filter_date = null;
      this.contract = null;
      this.filter_start_date_period = null;
      this.filter_end_date_period = null;
      this.resultGenerateReport = {};
    },
    clearGenerateReport() {
      this.SectionChecked = [];
      this.idSectionChecked = [];
      this.listCheckImagesBeforeAfter = [];
      this.listSelectedImagesBeforeAfter = [];
      this.listSelectedImagesOther = [];
      this.SelectedUpdateImagesBeforeAfter = null;
      this.SelectedUpdateImagesOther = null;
      this.listImagesBefore = [];
      this.listImagesAfter = [];
      this.listImagesOther = [];
      this.isGenerateReport = false;
      this.filter_start_date_period = null;
      this.filter_end_date_period = null;
      this.resultGenerateReport = {};
    },
    applyContract(data) {
      this.contract = data[0];
      this.idContract = data[0].id;

      let getStartDateContract = data[0].start_date.split("-");
      let startYearContract = getStartDateContract[0];
      let startMonthContract = getStartDateContract[1];
      this.filter_date = startMonthContract + "/" + startYearContract;
      this.clearGenerateReport();
    },
    AssignSection(data) {
      this.SectionChecked = data;
      this.idSectionChecked = [];
      this.SectionTask = [];
      this.listImagesBefore = [];
      this.listImagesAfter = [];
      this.listImagesOther = [];
      this.resultGenerateReport = {};
      for (let key in data) {
        this.idSectionChecked.push(data[key].id);
      }

      // console.log(this.idSectionChecked);

      this.getDataSectionTask();
    },
    AssignSectionTaskImage(data) {
      if (this.typeImage == "before") {
        for (let key in data) {
          this.listImagesBefore.push(data[key]);
        }
      }

      if (this.typeImage == "after") {
        for (let key in data) {
          this.listImagesAfter.push(data[key]);
        }
      }

      if (this.typeImage == "other") {
        for (let key in data) {
          this.listImagesOther.push(data[key]);
        }
      }

      this.listCheckImagesBeforeAfter = this.listImagesBefore.concat(
        this.listImagesAfter
      );
    },
    AssignSectionTaskImageNew(imgBefore, imgAfter, imgOther = null) {
      // console.log(imgBefore, imgAfter);
      if (imgOther == null) {
        if (imgBefore.date_work !== imgAfter.date_work) {
          alert("Before dan After harus berasal dari tanggal kerja yang sama.");
          return;
        }

        if (this.SelectedUpdateImagesBeforeAfter == null) {
          let dataImageBeforeAfter = {
            img_before_id: imgBefore.id,
            img_before_idqr: imgBefore.idqr,
            img_before_area: imgBefore.area,
            img_before_area_type: imgBefore.area_type,
            img_before_notes: imgBefore.notes,
            img_before_photo: imgBefore.photo,
            img_before_date_work: imgBefore.date_work,
            img_before_time: imgBefore.time,
            img_before_checkpoint_index: imgBefore.checkpoint_index,
            img_before_checkpoint_created_at: imgBefore.checkpoint_created_at,
            img_after_id: imgAfter.id,
            img_after_idqr: imgAfter.idqr,
            img_after_area: imgAfter.area,
            img_after_area_type: imgAfter.area_type,
            img_after_notes: imgAfter.notes,
            img_after_photo: imgAfter.photo,
            img_after_date_work: imgAfter.date_work,
            img_after_time: imgAfter.time,
            img_after_checkpoint_index: imgAfter.checkpoint_index,
            img_after_checkpoint_created_at: imgAfter.checkpoint_created_at,
          };

          this.listSelectedImagesBeforeAfter.push(dataImageBeforeAfter);
        } else {
          this.listSelectedImagesBeforeAfter[
            this.SelectedUpdateImagesBeforeAfter
          ] = {
            img_before_id: imgBefore.id,
            img_before_idqr: imgBefore.idqr,
            img_before_area: imgBefore.area,
            img_before_area_type: imgBefore.area_type,
            img_before_notes: imgBefore.notes,
            img_before_photo: imgBefore.photo,
            img_before_date_work: imgBefore.date_work,
            img_before_time: imgBefore.time,
            img_before_checkpoint_index: imgBefore.checkpoint_index,
            img_before_checkpoint_created_at: imgBefore.checkpoint_created_at,
            img_after_id: imgAfter.id,
            img_after_idqr: imgAfter.idqr,
            img_after_area: imgAfter.area,
            img_after_area_type: imgAfter.area_type,
            img_after_notes: imgAfter.notes,
            img_after_photo: imgAfter.photo,
            img_after_date_work: imgAfter.date_work,
            img_after_time: imgAfter.time,
            img_after_checkpoint_index: imgAfter.checkpoint_index,
            img_after_checkpoint_created_at: imgAfter.checkpoint_created_at,
          };
          this.SelectedUpdateImagesBeforeAfter = null;
        }
      } else {
        if (this.SelectedUpdateImagesOther == null) {
          for (let key in imgOther) {
            let dataImageOther = {
              img_other_id: imgOther[key].id,
              img_other_idqr: imgOther[key].idqr,
              img_other_area: imgOther[key].area,
              img_other_area_type: imgOther[key].area_type,
              img_other_notes: imgOther[key].notes,
              img_other_photo: imgOther[key].photo,
              img_other_date_work: imgOther[key].date_work,
              img_other_time: imgOther[key].time,
              img_other_checkpoint_index: imgOther[key].checkpoint_index,
              img_other_checkpoint_created_at:
                imgOther[key].checkpoint_created_at,
            };
            this.listSelectedImagesOther.push(dataImageOther);
          }
        } else {
          alert("Process Update Image Other");
          console.log(imgOther);
        }

        // console.log(this.listSelectedImagesOther);
      }

      window.scrollTo(0, document.body.scrollHeight + 100);
    },
    updateImageBeforeAfter(idx) {
      this.SelectedUpdateImagesBeforeAfter = idx;
      this.openNewGallery("BeforeAfter");
      this.galleryImageType = "BeforeAfter";
    },
    deleteImageOther(idx) {
      for (let i = 0; i < this.listSelectedImagesOther.length; i++) {
        if (i === idx) {
          this.listSelectedImagesOther.splice(i, 1);
        }
      }
    },
    AssignImage(data) {
      // console.log(data);
      this.ImagesSelectedNotes.photo = data.photo;
      this.ImagesSelectedNotes.notes =
        data.area +
        " Section " +
        data.section +
        " Floor " +
        data.floor +
        " " +
        data.type +
        " Notes:" +
        data.notes;

      // console.log(this.ImagesSelectedNotes);
    },
    disabledBeforeAfterFilterDate(date) {
      const start_date = new Date(this.contract.start_date);
      start_date.setHours(0, 0, 0, 0);
      const end_date = new Date(this.contract.end_date);
      end_date.setHours(0, 0, 0, 0);

      let dateNow = new Date(date.getFullYear(), date.getMonth());
      let dateStart = new Date(start_date.getFullYear(), start_date.getMonth());
      let dateEnd = new Date(end_date.getFullYear(), end_date.getMonth());

      return dateNow < dateStart || dateNow > dateEnd;
    },
    FilterModelDate() {
      let periodEndSplit = this.filter_date[1].split("/");

      let newEndPeriodLastDay = this.getLastDay(
        periodEndSplit[2],
        periodEndSplit[1]
      );

      const result_end_period =
        newEndPeriodLastDay + "/" + periodEndSplit[1] + "/" + periodEndSplit[2];

      this.filter_start_date_period = this.filter_date[0];
      // this.filter_end_date_period = result_end_period;
      this.filter_end_date_period = this.filter_date[1];
      this.idSectionChecked = [];
      this.SectionChecked = [];
      this.listImagesBefore = [];
      this.listImagesAfter = [];
      this.listImagesOther = [];
    },
    getLastDay(y, m) {
      return new Date(y, m, 0).getDate();
    },
    async getDataSectionTask() {
      this.isLoading = true;
      this.$store.state.loading.msg = "Query Data Section Room ...";
      this.$store.state.loading.status = true;
      // let param = {
      //   id: this.idContract,
      //   date_period: {
      //     start: this.filter_start_date_period,
      //     end: this.filter_end_date_period,
      //   },
      //   id_section_room: this.idSectionChecked,
      // };
      // console.log(param);
      await axios
        .post("contract/get-section-task", {
          id: this.idContract,
          date_period: {
            start: this.filter_start_date_period,
            end: this.filter_end_date_period,
          },
          id_section_room: this.idSectionChecked,
        })
        .then((res) => {
          // console.log(res);
          let data = res.data;
          for (let key in data) {
            let checkpoint = JSON.parse(data[key].checkpoint);
            for (let keyCheckPoint in checkpoint) {
              this.SectionTask.push({
                id: data[key].id,
                section: data[key].section,
                floor: data[key].area_floor,
                area_type: data[key].area_type,
                area: data[key].area_name,
                task: data[key].area_task,
                // date_work: data[key].date_work,
                date_work: checkpoint[keyCheckPoint].createdAt.split(' ')[0], // ambil date aja
                time: checkpoint[keyCheckPoint].time,
                idqr: checkpoint[keyCheckPoint].idqr,
                photo:
                  "https://astation.tukangbersih.com/" +
                  checkpoint[keyCheckPoint].photo,
                notes: checkpoint[keyCheckPoint].notes,
                type: checkpoint[keyCheckPoint].type,
                checkpoint_index: Number(keyCheckPoint),
                checkpoint_created_at: checkpoint[keyCheckPoint].createdAt,
              });
            }
          }
          this.isLoading = false;
        })
        .catch((error) => {
          console.log(error.statusText);
        })
        .finally(() => {
          this.$store.state.loading.status = false;
        });
    },
    openNewGallery(type) {
      this.isEnablePopup = "open_gallery_new";
      this.galleryImageType = type;
      window.scrollTo(0, 0);
    },
    openGallery(type) {
      this.isEnablePopup = "section_task";
      this.typeImage = type;
    },
    openGalleryImagesSelected() {
      this.listImagesSelectedGenerate =
        this.resultGenerateReport.images_before.concat(
          this.resultGenerateReport.images_after
        );

      this.isEnablePopup = "images_selected";
    },
    async ApplyGenerateReportSave(param) {
      this.isGenerateReport = true;
      this.$store.state.loading.msg = "Save " + param.status + " Report ..";
      this.$store.state.loading.status = true;

      let listOfBeforeImages = [];
      let listOfAfterImages = [];
      let listOfOtherImages = [];

      for (let key in this.listSelectedImagesBeforeAfter) {
        listOfBeforeImages.push({
          time: this.listSelectedImagesBeforeAfter[key].img_before_time,
          idqr: this.listSelectedImagesBeforeAfter[key].img_before_idqr,
          photo: this.listSelectedImagesBeforeAfter[key].img_before_photo,
          notes: this.listSelectedImagesBeforeAfter[key].img_before_notes,
          type_img: "before",
          contract_section_task_id:
            this.listSelectedImagesBeforeAfter[key].img_before_id,
          checkpoint_index:
            this.listSelectedImagesBeforeAfter[key].img_before_checkpoint_index,
          checkpoint_created_at:
            this.listSelectedImagesBeforeAfter[key]
              .img_before_checkpoint_created_at,
        });

        listOfAfterImages.push({
          time: this.listSelectedImagesBeforeAfter[key].img_after_time,
          idqr: this.listSelectedImagesBeforeAfter[key].img_after_idqr,
          photo: this.listSelectedImagesBeforeAfter[key].img_after_photo,
          notes: this.listSelectedImagesBeforeAfter[key].img_after_notes,
          type_img: "after",
          contract_section_task_id:
            this.listSelectedImagesBeforeAfter[key].img_after_id,
          checkpoint_index:
            this.listSelectedImagesBeforeAfter[key].img_after_checkpoint_index,
          checkpoint_created_at:
            this.listSelectedImagesBeforeAfter[key]
              .img_after_checkpoint_created_at,
        });
      }

      for (let key in this.listSelectedImagesOther) {
        listOfOtherImages.push({
          time: this.listSelectedImagesOther[key].img_other_time,
          idqr: this.listSelectedImagesOther[key].img_other_idqr,
          photo: this.listSelectedImagesOther[key].img_other_photo,
          notes: this.listSelectedImagesOther[key].img_other_notes,
          type_img: "other",
          contract_section_task_id:
            this.listSelectedImagesOther[key].img_other_id,
          checkpoint_index:
            this.listSelectedImagesOther[key].img_other_checkpoint_index,
          checkpoint_created_at:
            this.listSelectedImagesOther[key].img_other_checkpoint_created_at,
        });
      }

      let params = {
        id: param.id ? param.id : null,
        id_contract: this.idContract,
        id_section_room: this.idSectionChecked,
        create_by: localStorage.getItem("userid"),
        status: param.status,
        date_period: {
          start: this.filter_start_date_period,
          end: this.filter_end_date_period,
        },
        cleaning_images: {
          images_before: listOfBeforeImages,
          images_after: listOfAfterImages,
          images_other: listOfOtherImages,
        },
        executive_summary: param.notes,
        regards: param.regards,
      };

      // console.log(params);

      await axios
        .post(this.meta_url + "/save", params)
        .then((res) => {
          let response = res.data;
          if (response.result == "ok") {
            this.$store.state.alert.status = true;
            this.$store.state.alert.type = "success";
            this.$store.state.alert.msg = response.msg;
            router.push({
              name: "report/generate-report/detail",
              query: { report_id: response.id },
            });
          } else {
            this.$store.state.alert.status = true;
            this.$store.state.alert.type = "trash";
            this.$store.state.alert.msg = response.msg;
          }
        })
        .catch((error) => {
          console.log(error.statusText);
        });
    },
    async generateReport() {
      this.isGenerateReport = true;
      this.$store.state.loading.msg = "Generate Data...";
      this.$store.state.loading.status = true;

      await axios
        .post("report/generate-report-quantitative", {
          id_contract: this.idContract,
          id_section_room: this.idSectionChecked,
          date_period: {
            start: this.filter_start_date_period,
            end: this.filter_end_date_period,
          },
        })
        .then((res) => {
          let data = res.data;
          // console.log(data);
          this.resultGenerateReport = {
            params: {
              id_contract: this.idContract,
              id_section_room: this.idSectionChecked,
              create_by: localStorage.getItem("userid"),
              status: "draft",
              date_period: {
                start: this.filter_start_date_period,
                end: this.filter_end_date_period,
              },
              cleaning_images: {
                images_before_after: this.listSelectedImagesBeforeAfter,
                images_other: this.listSelectedImagesOther,
              },
              executive_summary: "",
            },
            contract_number: this.contract.contract_number,
            project_desc: this.contract.description,
            date_period: {
              start: this.filter_start_date_period,
              end: this.filter_end_date_period,
            },
            contract_start_date: this.contract.start_date,
            contract_end_date: this.contract.end_date,
            client_name: this.contract.client_name,
            client_phonenumber: this.contract.phone_number,
            client_email: this.contract.email,
            client_address: this.contract.office_address,
            section_room: this.SectionChecked,
            list_quantitative_absen: data.result_report_absen,
            list_quantitative_scan_barcode: data.result_report_scan_barcode,
            images_before_after: this.listSelectedImagesBeforeAfter,
            images_other: this.listSelectedImagesOther,
            notes: this.notes_default,
          };
          // window.scrollTo(0, 800);
          window.scrollTo({ top: 1000, behavior: "smooth" });
        })
        .catch((error) => {
          console.log(error.statusText);
        })
        .finally(() => {
          setTimeout(() => {
            this.$store.state.loading.status = false;
          }, 1300);
        });
    },
  },
};
</script>
<style scoped>
.report-create-page {
  color: #344a58;
}

.report-create-hero {
  align-items: center;
  background: linear-gradient(120deg, #326f9c 0%, #3193a7 58%, #55b9b8 100%);
  border-radius: 14px;
  box-shadow: 0 10px 25px rgba(45, 111, 145, 0.16);
  color: #fff;
  display: flex;
  justify-content: space-between;
  margin-bottom: 20px;
  min-height: 150px;
  overflow: hidden;
  padding: 25px 28px;
  position: relative;
}

.report-create-hero::after {
  background: rgba(255, 255, 255, 0.08);
  border-radius: 50%;
  content: "";
  height: 210px;
  position: absolute;
  right: -55px;
  top: -95px;
  width: 210px;
}

.report-create-hero > div,
.report-back-btn {
  position: relative;
  z-index: 1;
}

.report-create-hero__eyebrow {
  color: #c7f4eb;
  font-size: 11px;
  font-weight: 700;
  letter-spacing: 1.2px;
}

.report-create-hero h2 {
  color: #fff;
  font-size: 24px;
  font-weight: 700;
  margin: 5px 0 6px;
}

.report-create-hero p {
  color: rgba(255, 255, 255, 0.82);
  margin: 0;
}

.report-back-btn {
  align-items: center;
  background: rgba(255, 255, 255, 0.14);
  border: 1px solid rgba(255, 255, 255, 0.3);
  border-radius: 8px;
  color: #fff;
  display: inline-flex;
  font-size: 12px;
  font-weight: 600;
  gap: 7px;
  padding: 10px 14px;
  white-space: nowrap;
}

.report-back-btn:hover {
  background: rgba(255, 255, 255, 0.22);
  color: #fff;
}

.report-create-card,
.report-preview-card {
  border: 1px solid #e5ebf1;
  border-radius: 14px;
  box-shadow: 0 10px 28px rgba(41, 72, 105, 0.07);
  overflow: hidden;
}

.report-create-card > .card-body {
  padding: 26px;
}

.report-create-header,
.report-create-header__title,
.report-create-actions {
  align-items: center;
  display: flex;
}

.report-create-header {
  border-bottom: 1px solid #e8eef2;
  justify-content: space-between;
  padding-bottom: 20px;
}

.report-create-header__title {
  gap: 12px;
}

.report-create-header__icon,
.report-documentation__icon {
  align-items: center;
  background: #eaf6f7;
  border-radius: 10px;
  color: #2f8fa0;
  display: inline-flex;
  flex: 0 0 auto;
  font-size: 19px;
  height: 42px;
  justify-content: center;
  width: 42px;
}

.report-create-header h5,
.report-documentation__header h5 {
  color: #2d4452;
  font-weight: 700;
  margin: 0 0 3px;
}

.report-create-header small,
.report-documentation__header small {
  color: #8295a2;
}

.report-create-actions {
  gap: 8px;
}

.report-generate-btn,
.report-clear-btn {
  align-items: center;
  border-radius: 7px;
  display: inline-flex;
  font-size: 12px;
  font-weight: 600;
  gap: 6px;
  min-height: 38px;
}

.report-generate-btn {
  background: #3193a7;
  border-color: #3193a7;
  color: #fff;
}

.report-generate-btn:hover {
  background: #287f91;
  color: #fff;
}

.report-clear-btn {
  background: #fff4f2;
  border: 1px solid #f1d5d1;
  color: #b35a50;
}

.report-clear-btn:hover {
  background: #fbe9e6;
  color: #a14b42;
}

.report-create-steps {
  display: grid;
  gap: 12px;
  margin-top: 20px;
}

.report-step {
  background: #f8fafc;
  border: 1px solid #e2e9ef;
  border-radius: 10px;
  margin: 0;
  padding: 15px;
  transition: border-color 0.2s ease, background 0.2s ease;
}

.report-step--complete {
  background: #f5fbfa;
  border-color: #c8e5df;
}

.report-step__inner {
  align-items: center;
  display: flex;
  margin: 0 !important;
}

.report-step__number {
  align-items: center;
  background: #e4f2f4;
  border-radius: 50%;
  color: #2f8392;
  display: flex;
  flex: 0 0 auto;
  font-size: 12px;
  font-weight: 700;
  height: 30px;
  justify-content: center;
  margin-right: 13px;
  width: 30px;
}

.report-step--complete .report-step__number {
  background: #3193a7;
  color: #fff;
}

.report-step__label {
  color: #3d5563;
  font-size: 12px;
  font-weight: 700;
  padding-left: 0;
}

.report-step__label small {
  color: #8a9ca8;
  display: block;
  font-size: 10px;
  font-weight: 400;
  margin-top: 3px;
}

.report-step__control {
  padding-right: 0;
}

.report-picker-btn {
  align-items: center;
  background: #fff;
  border: 1px solid #d7e2e9;
  border-radius: 8px;
  color: #466071;
  display: flex;
  gap: 9px;
  min-height: 42px;
  padding: 9px 12px;
  width: 100%;
}

.report-picker-btn > i {
  color: #3193a7;
}

.report-picker-btn:hover {
  background: #f1f8f9;
  border-color: #9acdd3;
  color: #315968;
}

.report-picker-count {
  background: #e5f5f2;
  border-radius: 12px;
  color: #2c7c70;
  font-size: 10px;
  font-weight: 700;
  margin-left: auto;
  padding: 4px 8px;
}

.report-step__control::v-deep .mx-datepicker,
.report-step__control::v-deep .mx-input-wrapper,
.report-step__control::v-deep .mx-input {
  width: 100% !important;
}

.report-step__control::v-deep .mx-input {
  border: 1px solid #d7e2e9;
  border-radius: 8px;
  box-shadow: none;
  min-height: 42px;
}

.report-selected-sections {
  display: flex;
  flex-wrap: wrap;
  gap: 7px;
  margin-top: 10px;
  max-height: 180px;
  overflow-y: auto;
  padding: 2px;
}

.report-section-chip {
  align-items: center;
  background: #fff;
  border: 1px solid #d9e7e8;
  border-radius: 16px;
  color: #526b78;
  display: inline-flex;
  font-size: 10px;
  gap: 5px;
  padding: 5px 9px;
}

.report-section-chip i {
  color: #36a18e;
}

.report-documentation {
  background: #f8fafc;
  border: 1px solid #e2e9ef;
  border-radius: 12px;
  margin-top: 22px !important;
  padding: 18px !important;
}

.report-documentation__header,
.report-documentation__header > div {
  align-items: center;
  display: flex;
}

.report-documentation__header {
  border-bottom: 1px solid #e1e9ee;
  justify-content: space-between;
  margin-bottom: 16px;
  padding: 0 0 16px;
}

.report-documentation__header > div {
  gap: 11px;
}

.report-documentation__summary {
  background: #eaf6f7;
  border-radius: 14px;
  color: #327d89;
  font-size: 10px;
  font-weight: 700;
  padding: 6px 10px;
}

.report-documentation__column > .bd-callout {
  background: transparent;
  border: 0;
  margin: 0;
  padding: 0;
}

.report-documentation__column > .bd-callout > h5 {
  color: #496271;
  font-size: 12px;
  font-weight: 700;
  letter-spacing: 0.4px;
  margin-bottom: 10px;
  text-transform: uppercase;
}

.report-image-card {
  background: #fff;
  border: 1px solid #e1e8ed !important;
  border-radius: 9px;
  overflow: hidden;
  padding: 0;
}

.report-image-card > img {
  background: #edf2f4;
  height: 250px;
  object-fit: cover;
  width: 100%;
}

.report-update-image-btn,
.report-delete-image-btn {
  border-radius: 6px;
  font-size: 10px;
  font-weight: 600;
}

.report-update-image-btn {
  background: #eaf7f5;
  border: 1px solid #c4e6e0;
  color: #287a70;
}

.report-delete-image-btn {
  background: #fff1f1;
  border: 1px solid #f3d3d3;
  color: #c25353;
}

.report-gallery-btn {
  background: #eef8f8;
  border: 1px dashed #8dc9ce;
  border-radius: 8px;
  color: #2f7f8b;
  font-weight: 600;
  padding: 11px 14px;
  width: 100%;
}

.report-gallery-btn:hover {
  background: #e2f3f4;
  border-color: #59aeb6;
  color: #276e79;
}

.report-preview-card {
  background: #fff;
  padding: 18px;
}

@media (max-width: 767px) {
  .report-create-hero {
    align-items: stretch;
    flex-direction: column;
    min-height: 132px;
    padding: 22px 20px;
  }

  .report-back-btn {
    justify-content: center;
    margin-top: 18px;
    width: 100%;
  }

  .report-create-card > .card-body {
    padding: 16px;
  }

  .report-create-header,
  .report-step__inner,
  .report-documentation__header {
    align-items: stretch;
    flex-direction: column;
  }

  .report-create-actions {
    margin-top: 15px;
    width: 100%;
  }

  .report-create-actions .btn {
    flex: 1;
    justify-content: center;
  }

  .report-step__number {
    margin-bottom: 10px;
  }

  .report-step__label,
  .report-step__control {
    max-width: none;
    padding: 0;
    width: 100%;
  }

  .report-step__control {
    margin-top: 10px;
  }

  .report-documentation {
    padding: 14px !important;
  }

  .report-documentation__summary {
    margin-top: 12px;
    text-align: center;
  }

  .report-image-card > img {
    height: 210px;
  }
}
</style>
